import { getErrorToast, getErrorMessage, getSuccessToast } from '@utils';
import {
  GET_INVENTORY_ITEMS,
  UPDATE_INVENTORY_ITEM,
  SET_TOAST
} from '../types';

/* eslint-disable no-unused-vars */

export const importMetalWeightsCSV =
  (files) =>
  async (dispatch, _getState, { api }) => {
    try {
      const [file] = files;
      const form = new FormData();
      form.append('upload', file, file.name);

      const res = await api.post(`/inventory/item/material-weights/csv`, form, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });

      const {
        upsertedCount = 0,
        deletedCount = 0,
        missingSkus = []
      } = res.data || {};

      const parts = [];
      if (upsertedCount > 0) parts.push(`imported ${upsertedCount}`);
      if (deletedCount > 0) parts.push(`removed ${deletedCount}`);
      const changeSummary = parts.length
        ? `${parts.join(', ')} material weight(s)`
        : 'No material weights changed';
      const missingNote = missingSkus.length
        ? ` ${missingSkus.length} SKU(s) were not found and skipped.`
        : '';

      dispatch({
        type: SET_TOAST,
        payload: getSuccessToast({
          body: `${changeSummary}.${missingNote}`
        })
      });

      return res.data;
    } catch (e) {
      dispatch({
        type: SET_TOAST,
        payload: getErrorToast({
          body: getErrorMessage(e)
        })
      });

      return null;
    }
  };

export const describePartsImport = ({
  detailCount = 0,
  errors = [],
  warnings = []
} = {}) => {
  const notes = [
    errors.length ? `${errors.length} row(s) need attention` : '',
    warnings.length ? `${warnings.length} warning(s)` : ''
  ].filter(Boolean);
  const summary = detailCount
    ? `Imported ${detailCount} row(s).`
    : 'No parts were imported.';

  return notes.length ? `${summary} ${notes.join('. ')}.` : summary;
};

const postPartsImport =
  (path, files, { multiple = false, notify = true } = {}) =>
  async (dispatch, _getState, { api }) => {
    try {
      const form = new FormData();
      const uploads = multiple ? files : [files[0]];
      uploads.forEach((file) => form.append('upload', file, file.name));

      const res = await api.post(path, form, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });

      if (notify) {
        dispatch({
          type: SET_TOAST,
          payload: getSuccessToast({
            body: describePartsImport(res.data)
          })
        });
      }

      return res.data;
    } catch (e) {
      dispatch({
        type: SET_TOAST,
        payload: getErrorToast({
          body: getErrorMessage(e)
        })
      });

      return null;
    }
  };

export const importPartsByContainerCSV = (files) =>
  postPartsImport('/inventory/parts/container/csv', files);

export const importPartsByInventoryItemCSV = (files) =>
  postPartsImport('/inventory/parts/inventory-item/csv', files);

export const importExplodedViewImages = (files, { notify = true } = {}) =>
  postPartsImport('/inventory/parts/exploded-view', files, {
    multiple: true,
    notify
  });

export const getInventoryItems =
  ({ query, includeSND }) =>
  async (dispatch, _getState, { api }) => {
    try {
      const res = await api.post(`/inventory/item/search`, {
        query,
        includeSND
      });

      if (!res.data) {
        throw new Error(res.message);
      }

      dispatch({
        type: GET_INVENTORY_ITEMS,
        payload: res.data
      });
    } catch (e) {
      dispatch({
        type: SET_TOAST,
        payload: getErrorToast({
          body: getErrorMessage(e)
        })
      });
    }
  };

export const updateInventoryItem =
  (itemId, formValues) =>
  async (dispatch, getState, { api }) => {
    try {
      const res = await api.put(`/inventory/item/${itemId}`, formValues);

      if (!res.data) {
        throw new Error(res.message);
      }

      dispatch({
        type: UPDATE_INVENTORY_ITEM,
        payload: res.data
      });
    } catch (e) {
      dispatch({
        type: SET_TOAST,
        payload: getErrorToast({
          body: getErrorMessage(e)
        })
      });
    }
  };

export const addInventoryItem =
  (formValues) =>
  async (dispatch, getState, { api }) => {
    try {
      const res = await api.post(`/inventory/item/`, formValues);

      return res.data;
    } catch (e) {
      dispatch({
        type: SET_TOAST,
        payload: getErrorToast({
          body: getErrorMessage(e)
        })
      });

      return null;
    }
  };
